var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUiCustomisation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.57 2.42828C16.5883 1.44578 14.875 1.44578 13.8933 2.42828L6.91083 9.41078C6.83338 9.48811 6.77193 9.57994 6.73 9.68104C6.68808 9.78213 6.6665 9.8905 6.6665 9.99995C6.6665 10.1094 6.68808 10.2178 6.73 10.3189C6.77193 10.42 6.83338 10.5118 6.91083 10.5891L9.41083 13.0891C9.48804 13.1668 9.57984 13.2284 9.68096 13.2704C9.78207 13.3125 9.89049 13.3341 10 13.3341C10.1095 13.3341 10.2179 13.3125 10.319 13.2704C10.4202 13.2284 10.512 13.1668 10.5892 13.0891L17.5717 6.10662C18.0588 5.61842 18.3323 4.9568 18.332 4.2671C18.3317 3.57741 18.0576 2.91604 17.57 2.42828ZM16.3933 4.92828L10 11.3216L8.67833 9.99995L15.0717 3.60661C15.2497 3.43642 15.4866 3.34157 15.7328 3.34189C15.9791 3.3422 16.2158 3.43764 16.3933 3.60828C16.5678 3.78364 16.6657 4.02093 16.6657 4.26828C16.6657 4.51563 16.5678 4.75292 16.3933 4.92828ZM6.66667 12.4999C5.6125 11.9716 3.75 12.4999 3.75 14.1666C3.75 15.1641 4.16667 15.8333 2.5 16.6666C2.5 16.6666 5.20833 18.5416 7.08333 16.6666C8.145 15.6049 8.32833 13.3333 6.66667 12.4999Z",
    fill: "#74788D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiCustomisation);
export default __webpack_public_path__ + "static/media/ui-customisation.7d5c67b414745640936b76ac6684f0e4.svg";
export { ForwardRef as ReactComponent };